import { ProgressReportMasterDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProgressMaster = createAction(
  '[ProgressMaster] Load ProgressMaster'
);

export const loadProgressMasterSuccess = createAction(
  '[ProgressMaster] Load ProgressMaster Success',
  props<{ progressMaster: ProgressReportMasterDto[] }>()
);

export const loadProgressMasterFailure = createAction(
  '[ProgressMaster] Load ProgressMaster Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProgressMaster = createAction(
  '[ProgressMaster] Add ProgressMaster',
  props<{ newProgressMaster: ProgressReportMasterDto[] }>()
);

export const addProgressMasterSuccess = createAction(
  '[ProgressMaster] Add ProgressMaster Success',
  props<{ newProgressMaster: ProgressReportMasterDto[] }>()
);

export const addProgressMasterFailure = createAction(
  '[ProgressMaster] Add ProgressMaster Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProgressMasterRecord = createAction(
  '[ProgressMaster] Search  ProgressMaster Record',
  props<{ query: string }>()
);

/**
 * Update ProgressMaster Collection Actions
 */
export const updateProgressMaster = createAction(
  '[ProgressMaster] Update ProgressMaster',
  props<{ updateProgressMaster: ProgressReportMasterDto[] }>()
);

export const updateProgressMasterSuccess = createAction(
  '[ProgressMaster] Update ProgressMaster Success',
  props<{ updateProgressMaster: ProgressReportMasterDto[] }>()
);

export const updateProgressMasterFailure = createAction(
  '[ProgressMaster] Update ProgressMaster Failure',
  props<{ error: any }>()
);

/**
 * Remove ProgressMaster Collection Actions
 */
export const removeProgressMaster = createAction(
  '[ProgressMaster] Remove ProgressMaster',
  props<{ ids: string[] }>()
);

export const removeProgressMasterSuccess = createAction(
  '[ProgressMaster] Remove ProgressMaster Success',
  props<{ ids: string[] }>()
);

export const removeProgressMasterFailure = createAction(
  '[ProgressMaster] Remove ProgressMaster Failure',
  props<{ error: any }>()
);
